<template>
  <div
    class="visualization expenses-visualization"
    v-loading="loading"
    element-loading-spinner="presupuesto-loader"
  >
    <div v-if="data.length > 0">
      <h3>Honorarios, Rendiciones, Reembolsos y Otros</h3>

      <div class="card card-notas">
        <div
          class="card-body"
        >Esta vista contiene información detallada de honorarios de personas naturales, consultores especialistas que no tienen dependencia del servicio y que prestaron un servicio, consultoría o informe a suma alzada. También se puede visualizar rendiciones, reembolsos y otros gastos que son ejecutados en forma directa desde el servicio a una persona natural. Estos gastos no representan una adquisición de un bien servicio adquirido bajo la ley de compras públicas.</div>
      </div>
      <p></p>

      <div class="row">
        <div class="col-sm-10">
          <el-radio-group v-model="periodo">
            <el-radio-button v-for="p in periodos" :key="p" :label="p"></el-radio-button>
          </el-radio-group>
        </div>
        <div class="col-sm-2 text-right">
          <div class="mode-selector">
            <span class="title">Ver como</span>
            <div class="view-buttons">
              <el-tooltip content="Gráfico">
                <a href="#" @click.prevent="mode = 'chart'" :class="{active: mode === 'chart'}">
                  <i class="material-icons">dashboard</i>
                </a>
              </el-tooltip>
              <el-tooltip content="Tabla">
                <a href="#" @click.prevent="mode = 'table'" :class="{active: mode === 'table'}">
                  <i class="material-icons">view_list</i>
                </a>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>

      <div v-show="beneficiario === null">
        <div v-show="mode === 'chart'">
          <pyramid-chart
            v-show="beneficiario === null"
            :data="data"
            :dimensions="dimensions"
            @detail-clicked="detailClicked"
          ></pyramid-chart>
        </div>
        <table-chart
          :height="510"
          :data="data"
          v-show="mode === 'table'"
          @detail-clicked="detailClicked"
        ></table-chart>
      </div>

      <div v-show="beneficiario !== null">
        <div>
          <a href="#" @click.prevent="beneficiario = null">< Volver a la visualización</a>
        </div>
        <expenses-detail-visualization :where="detailWhere" ref="detailViz"></expenses-detail-visualization>
      </div>

      <visualization-footer :url="this.url"></visualization-footer>
    </div>
    <div v-else class="card card-notas">
      <div
        class="card-body"
      >Esta Institución registra información agregada para el pago de honorarios. Para el detalle de honorarios de este servicio, diríjase a la página de transparencia activa de la Institución.</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';
import PyramidChart from '../Charts/Pyramid';
import TableChart from '../Charts/Table';
import ExpensesDetailVisualization from './ExpensesDetail';
import VisualizationFooter from './Common/Footer';

export default {
    data: function() {
        return {
            periodo: this.$store.state.defaultYear,
            periodos: [],
            loading: false,
            data: [],
            mode: 'chart',
            dimensions: { ordinal: ['beneficiario'] },
            beneficiario: null
        };
    },
    props: ['institution'],
    components: {
        PyramidChart,
        TableChart,
        ExpensesDetailVisualization,
        VisualizationFooter
    },
    computed: {
        where: function() {
            let where = {
                periodo: this.periodo,
                honorario: true,
                partida: this.institution.partida
            };
            if (this.institution.capitulo)
                where.capitulo = this.institution.capitulo;
            if (this.institution.area) where.area = this.institution.area;

            return where;
        },
        detailWhere: function() {
            return _.assign(_.clone(this.where), {
                beneficiario: this.beneficiario
            });
        },
        url: function() {
            return (
                '/api/v1/data/pagos?group-by=' +
                JSON.stringify(['beneficiario']) +
                '&where=' +
                JSON.stringify(this.where) +
                '&order-by=["sum","asc"]'
            );
        }
    },
    methods: {
        clone: _.clone,
        assign: _.assign,
        detailClicked: function(n) {
            if (n.items) {
                this.beneficiario = n.items.map(d => {
                    return d.beneficiario;
                });
            } else {
                this.beneficiario = [n.beneficiario];
            }

            //this.$nextTick(()=>{
            //    this.$refs.detailViz.refreshData();
            //});
        },
        refreshData: function() {
            this.loading = true;
            axios.get(this.url).then(response => {
                this.loading = false;
                this.data = response.data;
            });
        }
    },
    watch: {
        periodo: function(value) {
            this.$store.commit("setDefaultYear", value)
            this.refreshData();
        }
    },
    mounted: function() {
        this.refreshData();

        axios
            .get(
                '/api/v1/data/pagos?distinct=' +
                    JSON.stringify(['periodo']) +
                    '&order-by=' +
                    JSON.stringify(['periodo'])
            )
            .then(response => {
                this.periodos = response.data.map(d => {
                    return d.periodo;
                });
            });
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/Components/Visualizations/People.vue